<template>
    <div>
        <b-container id="pageInfo" class="page" fluid>
            <b-row>
                <b-col sm="12">
                    <ul id="tabs" class="">
                        <li >
                            <a id="tabsItinerary" data-tabIndex="0" @click="changeTabs" class="tab active">Itinerary</a>
                        </li>
                        <li>
                            <a id="tabsTerms" data-tabIndex="1" @click="changeTabs" class="tab">Terms & Conditions</a>
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <b-row>
                <Itinerary class="tab-content-container"  v-if="this.tabIndex==0"></Itinerary>
                <Terms class="tab-content-container"  v-if="this.tabIndex==1"></Terms>
            </b-row>
            <b-row>
                <footer class="text-center pageFooter">
                    <a class="btn btn-negative btnPrevious" v-if="this.tabIndex != 0" @click="changeTabs">Back</a>
                    <a class="btn btn-primary btnNext" v-if="this.tabIndex != 1" @click="changeTabs">Next</a>
                    <router-link to="/registration" class="btn btn-danger" type="a" v-if="this.tabIndex == 1" @click="proceedRegister">Proceed with Registration</router-link>
                </footer>
            </b-row>
        </b-container><!-- page ends -->
    </div>
</template>

<script>
import Itinerary from './Itinerary';
import Terms from './Terms';

export default {
    name: 'Information',
    data() {
        return {
            tabIndex: 0
        }
    },
    props: [ 'showModal' ],
    components: {
        Itinerary,
        Terms
    },
    methods: {
        changeTabs(e) {
            e.preventDefault();
            const direction = e.target.text;
            const tabs = document.querySelectorAll('#tabs li');
            
            if (e.target.dataset.tabindex) {
                this.tabIndex = e.target.dataset.tabindex;
            }
            else {
                if (direction.toLowerCase() == 'next') {
                    this.tabIndex++;
                }
                else {
                    this.tabIndex--;
                }
            }

            tabs.forEach((tab, index)=> {
                if (index == this.tabIndex) {
                    tab.querySelector('a').classList.add('active');
                    tab.querySelector('a').classList.remove('disabled');
                }
                else {
                    tab.querySelector('a').classList.remove('active');
                }
            });
        },
        proceedRegister(e) {
            
            if (!document.querySelector('#cbTerms').checked) {
                window.console.log('hello');
                this.$emit('showModal','Warning', 'Please checked if you agree with the terms & conditions.');
                e.preventDefault();
            }
            
        }
    }
}
</script>

<style lang="less" scoped>

</style>